import React from "react";
import { ui } from "../../../../../../../interfaces/interfaces";
import Benefits from "./BenefitsTab";
import Discounts from "./DiscountsTab";
import TabPanel from "../../../../../../Shared/StepThreeTabPanel"
import useDebugInformation from "../../../../../../../hooks/useDebugInformation";
import ChargeRateTabHeader from "../../../../../../Shared/ChargeRateTabHeader";
import ChargeBanner from "./ChargeBanner";
import { Box, Typography } from "@mui/material";
import { useAppSelector } from "@store/hooks";
import SwipeableViews from "@arzymski/react-swipeable-views";

const name = "RatesTab"

const handleChangeIndex = (index: number) => {
  ui.RatesActiveTab = index
};

type Props = {
  parent: string
}

const RatesTab: React.FC<Props> = ({ parent }) => {
  const ratesActiveTab = useAppSelector(({ ui }) => ui.RatesActiveTab)
  const isAGoBack = useAppSelector(({ state }) => state.IsAGoBack)
  const isAQuote = useAppSelector(({ state }) => state.IsAQuote)
  const jobTypeCode = useAppSelector(({ state }) => state.JobTypeCode)

  const debugName = `${parent}▷[${name}]`

  useDebugInformation(debugName, { ratesActiveTab })
  return (
    <Box sx={(theme) => ({
      backgroundColor: theme.palette.background.paper,
      width: "100%",
      position: "relative",
      minHeight: 160,
      '& .react-swipeable-view-container > div': { overflow: "hidden !important" }

    })}>
      {(isAGoBack?.state || isAQuote) && <Typography variant="h4" sx={{ pt: 5 }} textAlign="center">{isAQuote ? "Our quotes team will go through what you would be charged to complete the works once the engineer has priced it up for you" : "No payment details to be requested from customer due to go-back process"}</Typography>}
      {
        !isAGoBack?.state && !isAQuote && <>
          <ChargeBanner parent={debugName} />
          <ChargeRateTabHeader parent={debugName} affix="Rates" />
          <SwipeableViews
            axis={"x"}
            index={ratesActiveTab}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel parent={debugName} value={ratesActiveTab} index={0} >
              <Benefits parent={debugName} />
            </TabPanel>
            {jobTypeCode !== 'HBSMK' && <TabPanel parent={debugName} value={ratesActiveTab} index={1}>
              <Discounts parent={debugName} />
            </TabPanel>}
          </SwipeableViews>
        </>
      }
    </Box >)
}

export default React.memo(RatesTab);